export default{
  tables:{
    bialystok:{
      id: 0,
      city: 'Białystok',
      carousel:[
        {
          id: 0,
          title: '',
          text: 'Białystok ul. Kilińskiego. Pomnik z tablicami.',
          img: "/historia/tablice_epitafijne/bialystok_kilinskiego.jpg"
        }
      ]
    },
    gdansk:{
      id: 1,
      city: 'Gdańsk',
      carousel:[
        {
          id: 0,
          title: '',
          text: 'Gdańsk. Bazylika Mariacka. Tablica epitafijna 3. Brygady „Szczerbca”.',
          img: "/historia/tablice_epitafijne/gdansk_mariacka1.jpg"
        },
        {
          id: 1,
          title: '',
          text: 'Gdańsk. Bazylika Mariacka. Tablica epitafijna 6. Brygady „Tońki” i „Konara”.',
          img: "/historia/tablice_epitafijne/gdansk_mariacka2.jpg"
        },
        {
          id: 2,
          title: '',
          text: 'Gdańsk. Bazylika Mariacka. Tablica epitafijna ORKO.',
          img: "/historia/tablice_epitafijne/gdansk_mariacka3.jpg"
        },
        {
          id: 3,
          title: '',
          text: 'Gdańsk. Bazylika Mariacka. Tablica epitafijna 7. Brygady „Wilhelma”.',
          img: "/historia/tablice_epitafijne/gdansk_mariacka4.jpg"
        },
        {
          id: 4,
          title: '',
          text: 'Gdańsk. Bazylika Mariacka. Tablica epitafijna Garnizonu miasta Wilna.',
          img: "/historia/tablice_epitafijne/gdansk_mariacka5.jpg"
        },
        {
          id: 5,
          title: '',
          text: 'Gdańsk. Bazylika Mariacka. Tablica epitafijna Ośrodka Mobilizacyjnego Okręgu Wileńskiego Armii Krajowej.',
          img: "/historia/tablice_epitafijne/gdansk_mariacka6.jpg"
        },
        {
          id: 6,
          title: '',
          text: 'Gdańsk. Bazylika Mariacka. Tablica epitafijna 8. Brygady „Tura”.',
          img: "/historia/tablice_epitafijne/gdansk_mariacka7.jpg"
        },
        {
          id: 7,
          title: '',
          text: 'Gdańsk. Bazylika Mariacka. Tablica epitafijna „Inki”.',
          img: "/historia/tablice_epitafijne/gdansk_mariacka8.jpg"
        },
        {
          id: 8,
          title: '',
          text: 'Gdańsk. Bazylika Mariacka. Tablica epitafijna Pomordowanym w Ponarach k/Wilna.',
          img: "/historia/tablice_epitafijne/gdansk_mariacka9.jpg"
        },
        {
          id: 9,
          title: '',
          text: 'Gdańsk. Bazylika Mariacka. Kaplica Matki Boskiej Ostrobramskiej.',
          img: "/historia/tablice_epitafijne/gdansk_mariacka10.jpg"
        },
        {
          id: 10,
          title: '',
          text: 'Gdańsk. Kościół p.w. Św. Brygidy. Tablica epitafijna Oddziałów bojowych Okręgów Wileńskiego i Nowogródzkiego.',
          img: "/historia/tablice_epitafijne/gdansk_mariacka11.jpg"
        },
        {
          id: 11,
          title: '',
          text: 'Gdańsk. Kościół p.w. Św. Brygidy. Tablica epitafijna mjr „Łupaszko”.',
          img: "/historia/tablice_epitafijne/gdansk_mariacka12.jpg"
        },
        {
          id: 12,
          title: '',
          text: 'Gdańsk. Kościół p.w. Św. Brygidy. Tablica epitafijna Żołnierzom Oddziału „Kmicica” oraz Brygad „Łupaszki” i „Ronina”.',
          img: "/historia/tablice_epitafijne/gdansk_mariacka13.jpg"
        }
      ]
    },
    krakow:{
      id: 2,
      city: 'Kraków',
      carousel:[
        {
          id: 0,
          title: '',
          text: 'Kraków. Kościół p/WSW. Jadwigi Królowej.',
          img: "/historia/tablice_epitafijne/krakow_1.jpg"
        },
        {
          id: 1,
          title: '',
          text: 'Kraków. Kościół p/WSW. Jadwigi Królowej.',
          img: "/historia/tablice_epitafijne/krakow_2.jpg"
        },
        {
          id: 2,
          title: '',
          text: 'Tablica upamiętniająca „wartę wileńską” ul. Loretańska 11, krużganki loretańskie kościoła OO. Kapucynów.',
          img: "/historia/tablice_epitafijne/krakow_3.jpg"
        },
        {
          id: 3,
          title: '',
          text: 'Tablica upamiętniająca 8. Brygadę „Tura”.',
          img: "/historia/tablice_epitafijne/krakow_4.jpg"
        }
      ]
    },
    lodz:{
      id: 3,
      city: 'Łódź',
      carousel:[
        {
          id: 0,
          title: '',
          text: 'Łódź ul. Św. Jerzego 9. Kościół Garnizonowy p.w. Św. Jerzego. Tablicę projektował: Modest Bobowicz „Wilcz” i Eugeniusz Czerniawski żołnierze AK Okręg Nowogródzki i Wileński.',
          img: "/historia/tablice_epitafijne/lodz_1.jpg"
        },
        {
          id: 1,
          title: '',
          text: 'Łódź ul. Retkińska 127. Kościół p.w. Najświętszego Serca Jezusowego. Tablicę projektował i ufundował płk Edward Stefanowicz AK Wilno.',
          img: "/historia/tablice_epitafijne/lodz_2.jpg"
        },
        {
          id: 2,
          title: '',
          text: 'Łódź ul. Retkińska 127. Kościół p.w. Najświętszego Serca Jezusowego. Tablicę projektował i ufundował płk Edward Stefanowicz AK Wilno.',
          img: "/historia/tablice_epitafijne/lodz_3.jpg"
        },
        {
          id: 3,
          title: '',
          text: 'Łódź ul. Kopcińskiego 1/3. Kościół p.w. Św. Teresy. Komendantowi i żołnierzom 23. Brygady.',
          img: "/historia/tablice_epitafijne/lodz_4.jpg"
        },
        {
          id: 4,
          title: '',
          text: 'Łódź ul. Kopcińskiego1/3. Kościół p.w. Św. Teresy.',
          img: "/historia/tablice_epitafijne/lodz_5.jpg"
        },
        {
          id: 5,
          title: '',
          text: 'Łódź ul. Kopcińskiego1/3. Kościół p.w. Św. Teresy.',
          img: "/historia/tablice_epitafijne/lodz_6.jpg"
        },
        {
          id: 6,
          title: '',
          text: 'Łódź ul. Sienkiewicza 60. Kościół p.w. Najświętszego Imienia Jezus..',
          img: "/historia/tablice_epitafijne/lodz_7.jpg"
        }
      ]
    },
    olsztyn:{
      id: 4,
      city: 'Olsztyn',
      carousel:[
        {
          id: 0,
          title: '',
          text: 'Olsztyn. Kościół Najświętszego Serca Jezusa. Tablica żołnierzom „Kmicica”.',
          img: "/historia/tablice_epitafijne/olsztyn_1.jpg"
        },
        {
          id: 1,
          title: '',
          text: 'Olsztyn. Kościół Najświętszego Serca Jezusa. Tablica 6. Brygady.',
          img: "/historia/tablice_epitafijne/olsztyn_2.jpg"
        },
        {
          id: 2,
          title: '',
          text: 'Zimna Woda k/Nidzicy. Tablica poświęcona „Łupaszce”.',
          img: "/historia/tablice_epitafijne/olsztyn_3.jpg"
        },
        {
          id: 3,
          title: '',
          text: 'Tablica epitafijna odsłonięta i poświęcona 09.091984 r. w kościele Matki Boskiej Ostrobramskiej w Rucianem - Nidzie.',
          img: "/historia/tablice_epitafijne/olsztyn_4.jpg"
        },
        {
          id: 4,
          title: '',
          text: 'Tablica epitafijna i pomnik ufundowany przez żołnierzy 13. Brygady w Rucianem – Nidzie',
          img: "/historia/tablice_epitafijne/olsztyn_5.jpg"
        },
        {
          id: 5,
          title: '',
          text: 'Olsztyn. Kościół p.w. Matki Boskiej Ostrobramskiej ul. Pana Tadeusza 16. Tablica Ponarska.',
          img: "/historia/tablice_epitafijne/olsztyn_6.jpg"
        },
        {
          id: 6,
          title: '',
          text: 'Pisz. Tablica Komendantowi i Żołnierzom 5. Brygady „Łupaszki”.',
          img: "/historia/tablice_epitafijne/olsztyn_7.jpg"
        },
        {
          id: 7,
          title: '',
          text: 'Olsztyn. Kościół p.w. Matki Boskiej Ostrobramskiej ul. Pana Tadeusza 16. Tablica poświęcona Komendantowi Okręgu Wileńskiego AK gen. A. Krzyżanowskiemu.',
          img: "/historia/tablice_epitafijne/olsztyn_8.jpg"
        },
        {
          id: 8,
          title: '',
          text: 'Ostróda. Kościół p.w. NMP ul. Czarneckiego. Tablica „Łupaszki”.',
          img: "/historia/tablice_epitafijne/olsztyn_9.jpg"
        }
      ]
    },
    szczecin:{
      id: 5,
      city: 'Szczecin',
      carousel:[
        {
          id: 0,
          title: '',
          text: 'Szczecin. Kościół p.w. Matki Boskiej Ostrobramskiej 3. Brygady „Szczerbca” Szczecin-Żelichowo.',
          img: "/historia/tablice_epitafijne/szczecin_1.jpg"
        },
        {
          id: 1,
          title: '',
          text: 'Szczecin. Kościół p.w. Matki Boskiej Ostrobramskiej 7. Brygady „Wilhelma” Szczecin-Żelichowo.',
          img: "/historia/tablice_epitafijne/szczecin_2.jpg"
        },
        {
          id: 2,
          title: '',
          text: 'Szczecin. Kościół p.w. Matki Boskiej Ostrobramskiej 2. Brygady „Kaziuka” Szczecin-Żelichowo.',
          img: "/historia/tablice_epitafijne/szczecin_3.jpg"
        }
      ]
    },
    warszawa:{
      id: 6,
      city: 'Warszawa',
      carousel:[
        {
          id: 0,
          title: '',
          text: 'Warszawa pl. Krasińskich Katedra Polowa Wojska Polskiego.',
          img: "/historia/tablice_epitafijne/warszawa_1.jpg"
        },
        {
          id: 1,
          title: '',
          text: 'Warszawa ul. Narbutta. Kościół OO Jezuitów. Tablica 1. Brygady „Juranda”.',
          img: "/historia/tablice_epitafijne/warszawa_2.jpg"
        },
        {
          id: 2,
          title: '',
          text: 'Warszawa ul. Senatorska 31. Kościół św. Antoniego. Tablica 5. Brygady „Łupaszki”.',
          img: "/historia/tablice_epitafijne/warszawa_3.jpg"
        },
        {
          id: 3,
          title: '',
          text: 'Warszawa ul. Senatorska 31. Kościół św. Antoniego.',
          img: "/historia/tablice_epitafijne/warszawa_4.jpg"
        },
        {
          id: 4,
          title: '',
          text: 'Warszawa ul. Senatorska 31. Kościół św. Antoniego. Tablica Pamięci Bolesława Krzyżanowskiego.',
          img: "/historia/tablice_epitafijne/warszawa_5.jpg"
        },
        {
          id: 5,
          title: '',
          text: 'Warszawa ul. Krakowskie Przedmieście 68. Kościół akademicki św. Anny. Tablica 6. Brygady „Tońki” i „Konara”.',
          img: "/historia/tablice_epitafijne/warszawa_6.jpg"
        },
        {
          id: 6,
          title: '',
          text: 'Warszawa ul. Krakowskie Przedmieście 68. Kościół akademicki św. Anny. Tablica Żeglarzom „Błękitnej Jedynki”.',
          img: "/historia/tablice_epitafijne/warszawa_7.jpg"
        },
        {
          id: 7,
          title: '',
          text: 'Warszawa ul. Krakowskie Przedmieście 68. Kościół akademicki św. Anny. Tablica nauczycielom Wileńskim.',
          img: "/historia/tablice_epitafijne/warszawa_8.jpg"
        },
        {
          id: 8,
          title: '',
          text: 'Warszawa ul. Freta 10. Kościół Dominikanów św. Jacka. Tablica Komendanta Okręgu Wileńskiego.',
          img: "/historia/tablice_epitafijne/warszawa_9.jpg"
        },
        {
          id: 9,
          title: '',
          text: 'Warszawa ul. Freta 10. Kościół Dominikanów św. Jacka. Tablica Ponarska.',
          img: "/historia/tablice_epitafijne/warszawa_10.jpg"
        },
        {
          id: 10,
          title: '',
          text: 'Warszawa ul. Freta 10. Kościół Dominikanów św. Jacka.',
          img: "/historia/tablice_epitafijne/warszawa_11.jpg"
        },
        {
          id: 11,
          title: '',
          text: 'Warszawa ul. Freta 10. Kościół Dominikanów św. Jacka. Tablica 13. Brygady „Nietoperza”.',
          img: "/historia/tablice_epitafijne/warszawa_12.jpg"
        },
        {
          id: 12,
          title: '',
          text: 'Warszawa. Tablica epitafijna 13. Brygady „Nietoperza”.',
          img: "/historia/tablice_epitafijne/warszawa_13.jpg"
        },
        {
          id: 13,
          title: '',
          text: 'Warszawa. Tablica Brygady „Jura”, „Orlicza” i „Tumrego”.',
          img: "/historia/tablice_epitafijne/warszawa_14.jpg"
        },
        {
          id: 14,
          title: '',
          text: 'Warszawa. Tablica pomordowanym w Berezweczu.',
          img: "/historia/tablice_epitafijne/warszawa_15.jpg"
        },
        {
          id: 15,
          title: '',
          text: 'Piastów k/Warszawy ul. Orzeszkowej 23. Kościół p.w. św. Michała Archanioła. Tablica pomordowanym w Ponarach k/Wilna.',
          img: "/historia/tablice_epitafijne/warszawa_16.jpg"
        }
      ]
    },
    wilno:{
      id: 7,
      city: 'Wilno',
      carousel:[
        {
          id: 0,
          title: '',
          text: 'Wilno. DOM Kultury Polskiej ul. Nougarduko 39.',
          img: "/historia/tablice_epitafijne/wilno_1.jpg"
        },
        {
          id: 1,
          title: '',
          text: 'Wilno. DOM Kultury Polskiej ul. Nougarduko 39.',
          img: "/historia/tablice_epitafijne/wilno_2.jpg"
        },
        {
          id: 2,
          title: '',
          text: 'Wilno. DOM Kultury Polskiej ul. Nougarduko 39.',
          img: "/historia/tablice_epitafijne/wilno_3.jpg"
        },
        {
          id: 3,
          title: '',
          text: 'Wilno. DOM Kultury Polskiej ul. Nougarduko 39.',
          img: "/historia/tablice_epitafijne/wilno_4.jpg"
        },
        {
          id: 4,
          title: '',
          text: 'Wilno. Puszcza Rudnicka. Rudniki miejsce pochówku żołnierzy Oddziału „Komara”.',
          img: "/historia/tablice_epitafijne/wilno_5.jpg"
        },
        {
          id: 5,
          title: '',
          text: 'Krawczuny k/Wilma. Miejsce walk Brygad AK z Wermachtem 13.07.1944',
          img: "/historia/tablice_epitafijne/wilno_6.jpg"
        },
        {
          id: 6,
          title: '',
          text: 'Wilno. Kościół Dominikanów p.w. św. Ducha. Tablica poświęcona Żołnierzom Armii Krajowej.',
          img: "/historia/tablice_epitafijne/wilno_7.jpg"
        }
      ]
    },
    wroclaw:{
      id: 8,
      city: 'Wrocław',
      carousel:[
        {
          id: 0,
          title: '',
          text: 'Wrocław. Kościół Garnizonowy pw. św. Elżbiety.',
          img: "/historia/tablice_epitafijne/wroclaw_1.jpg"
        },
        {
          id: 1,
          title: '',
          text: 'Wrocław. Kościół Garnizonowy pw. św. Elżbiety. Tablica St. Kiałki.',
          img: "/historia/tablice_epitafijne/wroclaw_2.jpg"
        },
        {
          id: 2,
          title: '',
          text: 'Wrocław. Kościół Garnizonowy pw. św. Elżbiety. Tablica „Kotwicza”.',
          img: "/historia/tablice_epitafijne/wroclaw_3.jpg"
        },
        {
          id: 3,
          title: '',
          text: 'Wrocław. Kościół Garnizonowy pw. św. Elżbiety. Tablica „Wilka”..',
          img: "/historia/tablice_epitafijne/wroclaw_4.jpg"
        },
        {
          id: 4,
          title: '',
          text: 'Wrocław. Kościół pw. św. Elżbiety przy Rynku. Tablica 3. Brygady „Szczerbca”.',
          img: "/historia/tablice_epitafijne/wroclaw_5.jpg"
        },
        {
          id: 5,
          title: '',
          text: 'Wrocław. Tablica M. Jończyka.',
          img: "/historia/tablice_epitafijne/wroclaw_6.jpg"
        },
        {
          id: 6,
          title: '',
          text: 'Wrocław. Tablica „Kima”.j.',
          img: "/historia/tablice_epitafijne/wroclaw_7.jpg"
        },
        {
          id: 7,
          title: '',
          text: 'Wrocław. Tablica 6. Brygady.',
          img: "/historia/tablice_epitafijne/wroclaw_8.jpg"
        }
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/historia/tablice_epitafijne.js